import { useMemo } from "react";
import { FieldValues } from "react-hook-form";

import { useLeadWorkflow } from "../../../lib/hooks/api/leads/useLeadWorkflow";
import { SelectProps } from "../../form_components/Inputs";
import { GroupedStageDropdownSelect } from "../../shared/stage/GroupedStageDropdownSelect";
import { ExtendedStageOption, processTransitions } from "../../shared/stage/utils";

type LeadStageDropdownSelectProps<T extends FieldValues> = Omit<
  SelectProps<T>,
  "options" | "onChange"
> & {
  fillbackground?: boolean;
  onChange?: (value: string, option?: ExtendedStageOption) => void;
  preventFormValueChange?: boolean;
};

/** @deprecated Old component refer to BidStageSelect/LeadStageSelect */
export function LeadStageDropdownSelect<T extends FieldValues>(
  props: LeadStageDropdownSelectProps<T>,
) {
  const { data, isLoading } = useLeadWorkflow();

  const options = useMemo(
    () => (data?.transitions ? processTransitions(data.transitions) : []),
    [data],
  );

  return <GroupedStageDropdownSelect {...props} options={options} loading={isLoading} />;
}
